import React, { Component } from 'react';
import {
  CART_EVENT_UPDATED,
  CART_TOGGLED,
  inSchoolCartService
} from './InSchoolCart.service';
import { events } from '../../../util/Events';
import { InSchoolCartItem } from './InSchoolCartItem';
import PropTypes from 'prop-types';
import $ from 'jquery';

const CartService = inSchoolCartService;

export class SearchSchoolCart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showMobileCart: false,
      cart: CartService.get(),
      //orderUrl: location.origin + location.pathname + 'order',
      orderUrl: location.origin + '/winkelwagen',
    };

    events.on(CART_EVENT_UPDATED, () => this._updateCart());
    events.on(CART_TOGGLED, () => this._toggleCart());

    $('#overlay').on('click', () => this._toggleCart());
  }

  _updateCart() {
    let showMobileCart = false;
    if (window.innerWidth < 992) {
      $('#overlay').toggle();
      showMobileCart = !this.state.showMobileCart;
    }

    this.setState({
      cart: CartService.get(),
      showMobileCart: showMobileCart,
    });
  }

  _toggleCart() {
    if (window.innerWidth < 992) {
      $('#overlay').toggle();
      this.setState({
        showMobileCart: !this.state.showMobileCart,
      });
    }
  }

  /**
   * Compare Cartlist data and see if there is any overlap
   */
  checkOverlap(cartlist) {
    let overlap = false;
    for (let i = 0; i < cartlist.length; i++){
      const startDate = new Date(cartlist[i].datum_start);
      const endDate = new Date(cartlist[i].datum_eind);
      if (i < (cartlist.length - 1)){
        for (let x = i+1; x < cartlist.length; x++) {
          const comparedStartDate = new Date(cartlist[x].datum_start);
          const comparedEndDate = new Date(cartlist[x].datum_eind);
          // eslint-disable-next-line max-depth
          if ((comparedStartDate >= startDate && comparedStartDate <= endDate)
            || (comparedEndDate >= startDate && comparedEndDate <= endDate)){
            overlap = true;
          }
        }
      }
    }
    return overlap;
  }

  render() {
    const { trainings, post } = this.props;
    const { showMobileCart, cart, orderUrl } = this.state;
    let cartItems = [];

    // get the trainings objects that match the ids in the cart
    if (trainings && trainings.length) {
      const cartTrainings = trainings
        .filter(training => cart.includes(training.id_training));

      cartItems = cartTrainings.map(training => {
        return (
          <InSchoolCartItem
            key={training.id_training}
            training={training}/>
        );
      });
    }

    let cartClass = 'school-page__cart';

    if (showMobileCart === true) {
      cartClass += ' school-page__cart--active';
    }

    let overlap = false;
    if (cartItems.length > 1){
      let cartlist = [];
      for (let i = 0; i < cartItems.length; i++){
        cartlist.push(cartItems[i].props.training);
      }
      if (this.checkOverlap(cartlist)){
        overlap = true;
      }
    }

    return (
      <div>
        <div className={cartClass}>
          <div className="school-page__cart-inner">
            <h4>Winkelwagen</h4>
            {overlap && <div className="school-page__cart-notice">
              {/* eslint-disable-next-line max-len */}
              <i className="fa fa-exclamation-triangle"/> Let op! Er zijn trainingen geselecteerd die (deels) op dezelfde data plaatsvinden.
            </div>}

            <ul className="school-page__cart-list">
              {cartItems}
            </ul>
            {!cartItems || cartItems.length === 0 && <div className="school-page__cart-empty">
                            Je winkelmand is momenteel leeg, voeg eerst een training toe.
            </div>}
            <a className="btn btn-primary btn-block"
              disabled={cart === null || cart.length === 0}
              href={orderUrl}>
                            Naar afrekenen
            </a>
          </div>
        </div>
        {post.sidebar_alert.notice
                && <a href={post.sidebar_alert.button} className="school-page__form-notice">
                  <div className="school-page__form-notice-content"
                    dangerouslySetInnerHTML={{ __html: post.sidebar_alert.notice }}></div>
                </a>}
      </div>
    );
  }
}

SearchSchoolCart.propTypes = {
  trainings: PropTypes.arrayOf(
    PropTypes.object
  ),
  post: PropTypes.object,
};

